export default {
  OrderItemTitle: 'จัดการรายการสั่งตรวจ',
  buttonnewOrderItem: 'เพิ่มรายการสั่งตรวจ',
  buttonnewOrderItemLanguage: 'เพิ่มภาษารายการสั่งตรวจ',
  buttonDeleteOrderItem: 'ลบรายการสั่งตรวจ',
  buttonDeleteOrderItemLanguage: 'ลบภาษารายการสั่งตรวจ',
  newOrderItem: 'เพิ่มรายการสั่งตรวจ',
  editOrderItem: 'แก้ไขรายการสั่งตรวจ',
  newOrderItemLanguage: 'เพิ่มภาษารายการสั่งตรวจ',
  editOrderItemLanguage: 'แก้ไขภาษารายการสั่งตรวจ',
  OrderItemName: 'ชื่อรายการสั่งตรวจ',
  confirmDelete: 'คุณต้องการที่จะลบรายการสั่งตรวจ {}?',
  confirmOrderItemLanguageDelete: 'คุณต้องการที่จะลบรายการสั่งตรวจภาษา {}?',
  confirmDeleteSelected: 'คุณต้องการที่จะลบรายการสั่งตรวจที่เลือก?',
  confirmOrderItemLanguageDeleteSelected: 'คุณต้องการที่จะลบภาษารายการสั่งตรวจที่เลือก?',
  progressMessageDelete: 'กำลังลบรายการสั่งตรวจ {}',
  progressMessageOrderItemLanguageDelete: 'กำลังลบภาษารายการสั่งตรวจ {}',
  messageDeleteNotSelected: 'กรุณาเลือกรายการสั่งตรวจที่จะลบ',
  messageDeleteLanguageNotSelected: 'กรุณาเลือกภาษารายการสั่งตรวจที่จะลบ',
  tabWindow: 'หน้าต่าง',
  tabLanguage: 'ภาษา',
  AddPicture: 'เพิ่มรูป',
  OrderItemDetail: 'รายละเอียดรายการสั่งตรวจ',
  copyHeader: 'คัดลอกข้อมูลส่วนหัว',
  comment: 'Comment',
  addNewComment: 'เพิ่ม comment ใหม่',
  orderItemId: 'รหัสรายการสั่งตรวจ'
}
